import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Http, Headers } from '@angular/http';
//import { HttpClientModule } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CoreService } from '../core/core.service';
import { TransactionService } from './transaction.service';
import { Main } from '../core/main.service';
import { EkubService } from '@app/ekub/ekub.service';

@Component({
  selector: 'cp-transaction-add',
  templateUrl: './transaction.add.component.html',
  styleUrls: ['./transaction.add.component.scss']
})

export class TransactionAddComponent {

  transaction: any = {};
  isLoading: any;
  id: string;
  ekubId: string;
  message: string = 'Transaction 1';
  transactionForm!: FormGroup;
  config: any;
  operation: string;
  ekubMembers: any[];
  selectedMember: any;

  // File

  file: any;
  files: File[] = [];
  banks: any = [
    { bank: 'Bank of Abyssinia', accronym: 'BOA' },
    { bank: 'Commercial Bank of Ethiopia', accronym: 'CBE' },
  ];
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;

  uploading = false;
  successUploadCount = 0;
  failedUploadCount = 0;
  error: string;
  userId: number = 1;
  uploadResponse = { status: '', message: '', filePath: '' };
  ekubs: any = [];

  constructor(private http: Http, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private coreService: CoreService,

    private imageCompress: NgxImageCompressService, private api: TransactionService, private ekubApi: EkubService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      // this.getTransaction();
    }
    if (this.route.queryParams['value']['ekub']) {
      this.ekubId = this.route.queryParams['value']['ekub'];
      this.getEkubMembers();
    }
    this.operation = !this.id ? 'add' : 'update';
  }

  get ekub() { return this.transactionForm.get('ekub'); }
  get user() { return this.transactionForm.get('user'); }
  get code() { return this.transactionForm.get('code'); }
  get bank() { return this.transactionForm.get('bank'); }
  get transaction_date() { return this.transactionForm.get('transaction_date'); }
  get type() { return this.transactionForm.get('type'); }
  get transaction_number() { return this.transactionForm.get('transaction_number'); }
  get amount() { return this.transactionForm.get('amount'); }
  get status() { return this.transactionForm.get('status'); }
  get remark() { return this.transactionForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getAllEkubs();
  }

  getAllEkubs() {
    this.ekubApi.getAllEkubs().subscribe((res: any) => {
      debugger;
      this.ekubs = res.data;
      for (let ekub of this.ekubs) {
        ekub.text = ekub.ekub_id + ' - ' + ekub.category.data.amount + '/' + ekub.category.data.interval;
        ekub.id = ekub.id;
      }
    });
  }

  private createForm() {

    this.transactionForm = this.formBuilder.group({
      ekub: ['', [Validators.required]],
      user: ['', [Validators.required]],
      bank: ['BOA', [Validators.required]],
      code: [''],
      transaction_date: ['', [Validators.required,]],
      type: ['deposit', [Validators.required,]],
      transaction_number: ['', Validators.required],
      amount: ['', Validators.required],
      status: ['pending', Validators.required],
      remark: [''],
    });
  }

  getTransaction() {
    this.api.getTransaction(this.id).subscribe((res: any) => {
      debugger;
      this.ekub.setValue(res.data.ekub.data.id);
      this.transaction_date.setValue(res.data.transaction_date.split(" ")[0]);
      this.transaction_number.setValue(res.data.transaction_number);
      this.type.setValue(res.data.type);
      this.status.setValue(res.data.status);
      this.amount.setValue(res.data.amount);
      this.remark.setValue(res.data.remark);
      this.setSelectedMember(res.data.user.data);
    });
  }

  getEkubMembers() {
    debugger;
    this.api.getEkubMembers(this.ekubId ? this.ekubId : this.ekub.value).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        for (let member of this.ekubMembers) {
          member.text = member.username + '-' + member.pivot.code;
          member.id = member.id;
        }
        this.getTransaction();
      }
    });
  }

  setSelectedMember(user: any) {
    debugger;
    const result = this.ekubMembers.filter(
      //(member: any) => (member.id.toLowerCase().indexOf((user.id)) !== -1 && member.pivot.code.toLowerCase().indexOf((user.pivot.code)) !== -1)
      (member: any) => (member.id.toLowerCase().indexOf((user.id)) !== -1)
    );
    this.selectedMember = result[0];
    //this.code.setValue(this.user.value.pivot.code);
    this.code.setValue(this.selectedMember.pivot.code);
    this.user.setValue(this.selectedMember);
  }

  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  setCategory(category: any) {
    debugger;
  }

  /*  calculateBetAmount() {
     debugger;
     this.bet_amount.setValue(this.market_value.value * this.bet_percentage.value);
   } */

  addTransaction() {
    debugger;
    this.isLoading = !this.isLoading;
    this.user.setValue(this.selectedMember.id);
    this.transaction = this.transactionForm.value;
    //var id = this.transaction.id != null ? this.transaction.id : null;
    this.api.createTransaction(this.transaction, this.id).subscribe((res: any) => {
      //this.api.createTransaction({ transaction: this.transaction }, this.id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Transaction successfully updated! ' : 'Transaction  successfully added!', type: 'dark' });
      this.router.navigate(['/transactions']);
    }, (err) => {
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Could not update transaction!' : 'Could not add transaction!', type: 'danger' });
    });

  }

}
